import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HierarchySetStatusPayload } from 'api/actions/hierarchy-set-status/hierarchy-set-status-payload';
import { HierarchySetStatusPathParameters } from 'api/actions/hierarchy-set-status/hierarchy-set-status-path-parameters';
import { HierarchySetStatusResponse } from 'api/actions/hierarchy-set-status/hierarchy-set-status-response';

type HierarchySetStatusQueryParameters = Record<string, any>;

/**
 * The path of the HierarchySetStatus action.
 */
export const hierarchySetStatusActionPath = new SweetPath<keyof HierarchySetStatusPathParameters>(
  '/api/hierarchy/status/{hierarchyId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized HierarchySetStatus actions.
 */
export default function createHierarchySetStatusAction(axios: AxiosInstance) {
  return function hierarchySetStatusAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HierarchySetStatusPathParameters;
    query?: HierarchySetStatusQueryParameters;
    payload: HierarchySetStatusPayload;
  }) {
    const path = hierarchySetStatusActionPath.insert(parameters);

    return axios.request<HierarchySetStatusResponse, HierarchySetStatusResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
